import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import { PlayerAhoyEvent } from "../player_ahoy_event"

export default function registerInitStartEvent ({ data }) {
  const getCodec = () => {
    // 'this' is a videojs player instance
    if(!data.drmEnabled() && this.dash){
      return 'vp9';
    }

    return 'h264';
  }

  this.one('play', () => {
    PlayerAhoyEvent.sendPlaybackInitStart({
      play_uuid: data.playUUID(),
      content_type: data.type(),
      content_id: data.videoId(),
      is_premium: data.isPremier(),
      quality: null,
      bandwidth: null,
      is_preview: data.preview(),
      codec: getCodec(),
      video_source_bitrate: null,
      video_source_height: null,
      video_source_width: null,
      player_height: this.currentHeight(),
      player_width: this.currentWidth(),
    });
  })
}



VideoJsAdapter.registerPlugin('initStartEvent', registerInitStartEvent)
